import { adminApi } from 'nove8/api'
import { ProcessingKey } from 'nove8/constants/root-constants'
import { useZustandStore } from 'zustandGlobalStore'

export const getUserHasChat = async (token: string): Promise<void> => {
  useZustandStore.getState().startProcessing(ProcessingKey.GET_USER_HAS_CHAT)

  const response = await adminApi.getUserHasChat(token)

  if (response?.data && response?.success) {
    const userHasChat = response.data?.has_chat
    useZustandStore.setState({ userHasChat })
  }

  useZustandStore.getState().stopProcessing(ProcessingKey.GET_USER_HAS_CHAT)
}
